<template>
  <div class="pt-16 overflow-auto">
    <section class="bg-gray-100 bg-opacity-50 p-2 h-screen w-full">
      <div class="mx-auto container max-w-5xl bg-gray-300 shadow-md border-b-4 border-blue-400">
        <div
          class="bg-gray-100 p-4 border-t-4 bg-opacity-5 border-blue-400 rounded-t"
        >
          <div class="flex items-center">
            <div class="inline-flex items-center space-x-4">
              <img
                class="w-10 h-10 object-cover rounded-full"
                alt="User avatar"
                :src="image"
              />  <label class="text-xl font-bold text-gray-600">Profil setting</label>
              <h1 class="text-gray-700 font-semibold capitalize"></h1>
            </div>
            <div class="ml-auto" v-if="$f.getAccessPermission(currentUser, 'userSessions', 'create')">
              <button :disabled="loading" @click="checkLogs()" class="ttr loidingconfirm relative"><svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-2.995 2.995-7.486 4-11 4 0 8.582 5.068 16.097 11 20 5.932-3.903 11-11.418 11-20-3.514 0-8.005-1.005-11-4zm-8.912 5.894c2.455-.246 5.912-1.012 8.912-3.25v18.906c-4-3.063-8.254-8.604-8.912-15.656z"/></svg> 
                Where you're logged in <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              </button>
            </div>
          </div>
        </div>

        <div class="bg-white space-y-6">
          <div v-if="messages" class="alert mx-2 alert-outline-warning flex items-center mb-2 show" role="alert" style="display: flex;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="bx-burst lucide w-6 h-6 mr-2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
             {{messages}}
           </div>
          <div
            class="md:inline-flex md:space-y-0 w-full p-2 text-gray-600 items-center"
          >
            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm font-bold text-gray-500">Email</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">mail</i>
                </div>
                <span class="p-2">{{ currentUser.email }}</span>
              </div>
            </div>

            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm font-bold text-gray-500">Role</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">lock</i>
                </div>
                <input
                  type="text"
                  v-model="currentUser.role.name"
                  class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2"
                  placeholder="role"
                  disabled
                />
              </div>
            </div>
          </div>

          <div
            class="md:inline-flex md:space-y-0 w-full p-1 text-gray-600 items-center"
          >
            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm font-bold text-gray-500">full Name *</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">person</i>
                </div>
                <input
                  type="text"
                  v-model="currentUser.fullName"
                  class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2"
                  placeholder="fullName"
                />
              </div>
            </div>

            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm font-bold text-gray-500">phone</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">person</i>
                </div>
                <input
                  type="text"
                  v-model="currentUser.phone"
                  class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2"
                  placeholder="phone"
                />
              </div>
            </div>
          </div>

          <div
            class="md:inline-flex md:space-y-0 w-full p-1 text-gray-600 items-center"
          >
            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm font-bold text-gray-500">Username</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">person</i>
                </div>
                <input
                  type="text"
                  v-model="currentUser.username"
                  class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2"
                  placeholder="username"
                  @keydown.space="(event) => event.preventDefault()"
                  @keydown="nameKeydown($event)"
                  :disabled="isDisabled"
                />
              </div>
            </div>

            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm font-bold text-gray-500">Company</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">business</i>
                </div>
                <input
                  type="text"
                  v-model="currentUser.company"
                  class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2"
                  placeholder="company"
                />
              </div>
            </div>
          
          </div>
          <div v-if="currentUser.type=='Seller'" class="md:inline-flex md:space-y-0 w-full p-1 text-gray-600 items-center">
               <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm font-bold text-gray-500">RIB *</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">account_balance_wallet</i>
                </div>
                <input
                  type="text"
                  v-model="currentUser.rib"
                  class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2"
                  placeholder="RIB"
                />
              </div>
            </div>
          </div>

          <hr />

          <div class="md:inline-flex w-full space-y-4 md:space-y-0 justify-center text-gray-600 items-center">
            <span class="text-gray-700 font-semibold"> Change password</span>
            <div class="md:w-1/12 justify-end text-center md:pl-6">
              <button v-on:click="seen = !seen" class="text-white hover:bg-blue-600 rounded-full bg-blue-500 flex items-center focus:outline-none p-2 ml-2">
                <i class="material-icons"><span v-if="!seen">keyboard_arrow_down</span><span v-else>keyboard_arrow_up</span></i>
              </button>
            </div>
          </div>

          <hr  />

          <div  v-if="seen"
            class="md:inline-flex w-full space-y-4 md:space-y-0 p-4 text-gray-600 items-center"
          >
            <div
              class="md:w-5/12 w-full md:pl-9 max-w-sm mx-auto space-y-5 md:inline-flex pl-2"
            >
              <div class="w-full inline-flex border-b hover:border-blue-400">
                <div class="w-1/12 pt-2">
                  <svg
                    fill="none"
                    class="w-6 text-gray-500 mx-auto"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                </div>
                <input
                  type="password"
                  v-model="currentUser.password"
                  class="w-11/12 focus:outline-none focus:text-gray-600 p-2 ml-4"
                  placeholder="New password"
                />
              </div>
            </div>

            <div
              class="md:w-5/12 w-full md:pl-9 max-w-sm mx-auto space-y-5 md:inline-flex pl-2"
            >
              <div class="w-full inline-flex border-b hover:border-blue-400">
                <div class="w-1/12 pt-2">
                  <svg
                    fill="none"
                    class="w-6 text-gray-500 mx-auto"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                </div>
                <input
                  type="password"
                  v-model="currentUser.confirmPassword"
                  class="w-11/12 focus:outline-none focus:text-gray-600 p-2 ml-4"
                  placeholder="Confirm password"
                />
              </div>
            </div>
          </div>
           <div v-if="currentUser.status == 'inactive'" class="ml-20 mr-20">
            <div
              class="alert flex flex-row items-center bg-yellow-200 p-5 rounded border-b-2 border-yellow-300"
            >
              <div
                class="alert-icon flex items-center bg-yellow-100 border-2 border-yellow-500 justify-center h-10 w-10 flex-shrink-0 rounded-full"
              >
                <span class="text-yellow-500">
                  <svg fill="currentColor" viewBox="0 0 20 20" class="h-6 w-6">
                    <path
                      fill-rule="evenodd"
                      d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </span>
              </div>
              <div class="alert-content ml-4">
                <div class="alert-title font-semibold text-lg text-yellow-800">
                  Warning
                </div>
                <div class="alert-description text-sm text-yellow-600">
                  You must change your password
                </div>
              </div>
            </div>
          </div>
          <hr v-if="seen" />
          <div
            class="md:inline-flex w-full space-y-4 justify-center md:space-y-0 p-2 text-gray-600 items-center"
          >
            <div class="md:w-3/12 text-center md:pl-6 pb-8">
              <button
                @click="update"
                class="text-white w-full mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 inline-flex items-center focus:outline-none md:float-right"
              >
                <i class="material-icons mr-8">save </i>
                Save
              </button>
            </div>
          </div>

         
        </div>
      </div>
    </section>
    <vue-modal-2 name="myModalLogs" :headerOptions="{title: 'Where youre logged in'}" :noFooter="true" modalSize="lg">
   
            <div class="flex flex-col w-full h-auto">
            <!-- Header -->
            <!-- Modal Content-->
            <div class="bg-white rounded px-2  pb-2 flex flex-col relative">
             
               <loading :active.sync="loading" :is-full-page="fullPage"></loading>
          
                 <div v-for="(item, index) in userSessions" :key="index" class="tr-t">
                   <div class="tr-t1">
                    <div class="_ohe lfloat"><div class="_a7x img _8o _8r"><img alt="Macintosh" :src="getFlag(item.device)" class="img"></div></div>
                    <div class="tr-t2">
                        <div class="">
                          <div class="_ohe lfloat">
                            <div>
                              <span class="_3o7u">
                                {{ item.device && item.device.name?item.device.type=='smartphone'?'Phone':item.device.name:'Device type unknown' }} · 
                                <span data-hover="tooltip" id="js_1yq">{{ item.info.city||'City unknown'  }}, {{ $f.getCountryNameByCode(options,item.info.country)  }}</span>
                              </span>
                              <span class="_1aml _50f8">{{ item.device?item.device.client.name:'REST API' }} ,</span>
                             </div>
                          </div>
                          <span class="_1anp _1aml date-tr">{{ item.date }}</span>
                        </div>
                    </div>
                   </div>
                 </div>
               
                
            </div>
            <div class="modal-footer px-5 border0-t text-right">
                  <div class="flex-auto flex flex-row-reverse">
                      <button :disabled="loading" @click="RefreshToken" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> Log out of all sessions</button>
                      <button :disabled="loading"  @click=" $vm2.close('myModalLogs')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Close</button>
                  </div>
             </div>
            <!-- End of Modal Content-->
          </div>
         </vue-modal-2>
  </div>
</template>

<script>
import DivFilter from "../components/DivFilter.vue";
import image from "@/assets/shipsen-man.jpg";
import Button from '../components/~/button.vue';
export default {
  components: { DivFilter, Button },
  name: "Profil",
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      isDisabled: false,
      loading:false,
      fullPage:false,
      show: false,
      image: 'https://img.icons8.com/fluency/96/user-male-circle--v1.png',
      messages:'',
      seen: false,
      userSessions:[],
      options: this.$countries,
     
    };
  },
  async mounted() {
     this.token = this.$jwtService.verifyToken();
     this.getUser();
  },
  methods: {
    getFlag(device){
     let src='https://img.icons8.com/carbon-copy/37/null/api-settings.png';
      if(device){
          src='https://www.facebook.com/images/si/security_settings/wyli/device-mac.png';
          if(device.type){
            if(device.type=='smartphone') src='https://www.facebook.com/images/si/security_settings/wyli/device-generic-phone.png';
            else{
              if(device.name=='Mac') src='https://www.facebook.com/images/si/security_settings/wyli/device-mac.png';
              else src='https://www.facebook.com/images/si/security_settings/wyli/device-windows.png';
            }
          }
      }
      
       return src;
    },
    async RefreshToken(){
          this.loading=true;
          const dataa = await this.$server.update("userSessions",{RefreshToken:true});
          console.log('dataa RefreshToken-----',dataa)
          this.loading=false;
          if(dataa && dataa._id) {
             alert("All Session deleted", "success");
             this.$vm2.close('myModalLogs');
          }else  alert(dataa.content||dataa, "warning");
    },
    async checkLogs(){
      this.loading=true;
      const res = await this.$server.search("userSessions", {});
      if (res && res.content.results) {
        this.userSessions = res.content.results;
        this.userSessions.forEach((value, key) => {
          value.date=this.$moment(value.date).format("MMMM Do YYYY, h:mm A");
        });
      } else this.userSessions = [];
      //console.log('dataa usersession-----',dataa)
      this.loading=false;
      if(this.userSessions.length>0) this.$vm2.open('myModalLogs');
      else  alert('No activity logs found', "warning");
    },
     getUser() {
      if(this.currentUser.username) this.isDisabled = true;
      this.checkUserMessage();
      // const res = await this.$server.me("users");
      // if (res.content) {
      //   if (res.content.username) {this.isDisabled = true; }
      //   this.currentUser = res.content;
      //   this.checkUserMessage();
      // }
    },
    showBar() {
      if (this.show) this.show = false;
      else this.show = true;
    },
    checkUserMessage(){
       this.messages='';
       this.seen=false;
       if(this.currentUser.status=='inactive') this.seen=true;
       if(this.currentUser.type=="Seller" && (!this.currentUser.fullName || !this.currentUser.rib)){
          if(!this.currentUser.fullName) this.messages='full Name is required ';
          if(!this.currentUser.rib){
               if(!this.currentUser.fullName) this.messages +='&& ';
               this.messages +='RIB is required ';
          } 
        }
    },
    async update() {
      console.log('this.checkData()---',this.checkData())
      if(this.checkData()){
        console.log('this.currentUser------',this.currentUser)
      this.$confirm("Are you sure ?").then(async (res) => {
        if (res) {
          if(this.currentUser.password) this.currentUser.password=this.currentUser.password.trim();
          if(this.currentUser.confirmPassword) this.currentUser.confirmPassword=this.currentUser.confirmPassword.trim();
           console.log('this.currentUser.--------',this.currentUser)
          if (this.currentUser.status == "inactive" && this.currentUser.password) {
            if (this.checkPassword()) {
              this.currentUser.status = "active";
              this.currentUser.Updatestatus=true;
              const dataa = await this.$server.update("users", this.currentUser);
              console.log('data- 11111----',dataa)
              if (dataa && dataa._id) {
                alert("Profil updated", "success");
                this.logout();
                this.currentUser.password = "";
                this.currentUser.confirmPassword = "";
              }else alert(dataa, "warning");
            }
          } else {
            const data = await this.$server.update("users", this.currentUser);
            if (data && data._id) {
              alert("Profil updated", "success");
              this.currentUser.password = "";
              this.currentUser.confirmPassword = "";
              this.getUser();
            }else alert(data, "warning");
          }
        }
      });
      }else alert('You must fill all the fields !!', "warning");
    },
    checkPassword() {
      if (this.currentUser.password == this.currentUser.confirmPassword) {
        return true;
      } else {
        alert("Confirmation password does not match ", "warning");
        return false;
      }
    },
    checkData() {
      if(this.currentUser.type == "Seller"){
         if(this.currentUser.rib &&  this.currentUser.email  && this.currentUser.fullName) return true;
         else return false;
      }else{
         if(this.currentUser.email) return true;
         else return false;
      }
     
    },
    logout() {
      this.$jwtService.destroyToken();
      location.href = "/";
    },
    nameKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
  },
};
</script>


<style scoped>
.icon::after {
  content: "";
  display: block;
  position: absolute;
  border-top: 23px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 12px solid #3182ce;
  left: 100%;
  top: 0;
}
.font-18 {
  font-size: 18px;
}
.me-1 {
  margin-right: .25rem !important;
}
.align-middle {
  vertical-align: middle !important;
}
.bx-rotate-90 {
  transform: rotate(90deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
}
.bx-burst, .bx-burst-hover:hover {
  animation: burst 1.5s infinite linear;
}
.bx {
  font-family: boxicons !important;
  font-weight: 400;
  font-style: normal;
  font-feature-settings: normal;
  font-variant: normal;
  line-height: inherit;
  display: inline-block;
  text-transform: none;
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@keyframes burst {
 0% {
  transform:scale(1);
  opacity:1
 }
 90% {
  transform:scale(1.5);
  opacity:0
 }
}
.alert-outline-warning {
  --tw-border-opacity: 1;
  border-color: #f97316;
  --tw-text-opacity: 1;
  color: #f97316;
}
.alert {
  position: relative;
  border-radius: .375rem;
  border-width: 1px;
  padding: 1rem 1.25rem;
}
.ttr{
  font-size: 15px;
line-height: 40px;
font-weight: 600;
color: #1d2129;
word-wrap: break-word;
cursor: pointer;
}
.tr-t1{
  border-bottom: 1px solid #8a8787;
padding: 12px;
font-size: 14px;
position: relative;
}
._ohe {
  float: left;
  font-size: 14px;
}
.tr-t2{
  overflow: hidden;
}
._3o7u {
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
}
._1aml {
  font-size: 15px;
  color: #90949c;
  display: block;
}
.date-tr{
  float: right;
}
</style>


